<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 13.0664H6.66699L7.33301 11L8 13.0664Z"
      fill="#929292"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.2002 2C21.3334 2.0001 22.2002 2.86673 22.2002 4V11.333C22.2002 12.4663 21.3334 13.3329 20.2002 13.333H12.8662V16C12.8662 17.1046 11.9708 18 10.8662 18H8.40039L4.2002 21.4004V18H3.5332C2.39993 17.9999 1.5332 17.1333 1.5332 16V8.66699C1.5332 7.5337 2.39993 6.66705 3.5332 6.66699H12.2002V5.33301H9.5332V4C9.5332 2.89543 10.4286 2 11.5332 2H20.2002ZM6.5332 9.33301L4.33301 15.2666H5.93359L6.33301 14.2002H8.40039L8.7334 15.2666H10.333L8.13379 9.33301H6.5332ZM15.4668 4V5.33301H13.4668V6.66699H17.4668C17.4001 7.66686 16.9335 8.53385 16.2002 9.13379C15.7336 8.73389 15.3338 8.26678 15.1338 7.66699H13.7334C13.9334 8.46687 14.3337 9.19989 14.9336 9.7998C14.4669 9.93314 13.9999 10 13.5332 10L13.5996 11.333C14.5329 11.2663 15.4666 11.0669 16.2666 10.667C17.0664 11.0669 17.9997 11.3329 18.8662 11.333V10C18.4664 9.99995 18.0661 9.93309 17.5996 9.7998C18.5996 8.7998 19.1331 7.4 19.0664 6L19 5.33301H16.7998V4H15.4668Z"
      fill="#929292"
    />
  </svg>
</template>
